export class Version {
  static readonly id = '4.3.67';
  static readonly experimental = false;
}
